module.exports = __webpack_public_path__ + "static/img/kjlogo.dc84f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/kjlogo.png
// module id = /Upi
// module chunks = 0